<template>
  <div class='custom-select select-single-option' v-click-outside='close'>
    <input type='hidden' :name='name' :value='value.id' v-if='hasSelected' />

    <div @click.prevent='open'>
      <input type='text' v-model='q'>

      <div v-if='hasSelected' class='selected-option single-selected-option'>
        <ul>
          <li>
            <span @click.prevent="clear">x</span>
            {{ template(value) }}
          </li>
        </ul>
      </div>
    </div>

    <ul v-show='opened' class='options-list'>
      <li @click.prevent='select(o)' v-for='o in filteredOptions' :key='o.id'>
        {{ template(o) }}
      </li>
      <li v-show='filteredOptions.length == 0'>
        {{ $t('no_results') }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      options: {
        type: Array,
        required: true,
        validator: (opts) => opts.reduce((s, o) => s && o.id, true)
      },
      name: {
        type: String
      },
      value: {
        type: Object,
        default: () => ({})
      },
      template: {
        type: Function,
        default: (x) => x.name
      }
    },
    data() {
      return {
        q: '',
        opened: false
      }
    },
    computed: {
      query() {
        return this.q.toLowerCase()
      },
      selected() {
        return this.$props.value || {}
      },
      currentUserOption(){
        return new Object({
          id: null,
          name: this.currentUser.full_name + (this.$t('folders.list.you_1')),
          email: this.currentUser.email
        })
      },
      filteredOptions() {
        const isQueryInOpt = (opt) => {
          return this.q == '' || this.template(opt).toLowerCase().indexOf(this.query) >= 0
        }

        return this.options.filter(opt => isQueryInOpt(opt) && opt.id != this.selected.id)
      },
      hasSelected() {
        return Object.keys(this.selected).length > 0
      },
    },
    methods: {
      open() {
        this.opened = true
      },
      close() {
        this.opened = false
      },
      select(option) {
        this.opened = false
        this.q = ''
        this.$emit('input', option)
      },
      clear() {
        this.$emit('input', [])
      }
    }
  }
</script>

<style lang='sass' scoped>
  @import "../../styles/select"
</style>
